export const addQuestionMark = (url: string) => {
    return url ? `?${url}` : url;
};
